// Аккордеон FAQ: каждый вопрос открывается и закрывается независимо, высота анимируется стилями
export default function faqAccordion() {
  document.querySelectorAll('[data-faq-accordion]').forEach((root) => {
    [...root.children].forEach((item) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      trigger?.addEventListener('click', () => {
        const open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', String(open));
      });
    });
  });
}
